import { BASE_URL } from "@/constants/endpoints";
import { SlotMainData, SlotSampleData } from "@/pages/grain-requests/slot-requests/schema/slot-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let SlotRequestApiPromise: Promise<AxiosInstance> | null = null;

const getSlotRequestApi = async (): Promise<AxiosInstance | null> => {
  if (SlotRequestApiPromise) return SlotRequestApiPromise;
  SlotRequestApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return SlotRequestApiPromise;
};

export interface GetSlotRequestsProps {
  fecha?: string;
  estados?: number[];
  nroCuenta?: string;
  grano?: number;
  procedencia?: string;
  cuposDirectos?: number;
  cuposAPlanta?: number;
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getSlotRequests = async (props: GetSlotRequestsProps) => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.get(
    `/SolicitudCupos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetSlotRequestProps {
  id: number;
}

export const getSlotRequest = async (props: GetSlotRequestProps) => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.get(
    `/SolicitudCupos/${props.id}`,
  );

  return response.data;
};

export interface CreateSlotRequestProps {
  nroCuentaOrigen: string;
  grano: number;
  cosecha: string;
  mensaje: string;
  cuposDirectos: number;
  cuposAPlanta: number;
  procedencia: string;
}

export const createSlotRequest = async (props: CreateSlotRequestProps) => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.post(
    `/SolicitudCupos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateSlotRequestProps {
  mensaje?: string;
  estado?: number;
  cuposAAsignar?: string[];
}

export const updateSlotRequest = async (id: number, props: UpdateSlotRequestProps) => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.patch(
    `/SolicitudCupos/${id}?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetAvailableSlotsProps {
  nroCuenta: number;
  idSolicitud: number
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getAvailableSlots = async (
  props: GetAvailableSlotsProps,
): Promise<{cupos: SlotSampleData[] | undefined, totalRecords: number, totalPages: number} | undefined> => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.get(
    `/SolicitudCupos/Disponibles?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetAvailableSlotsProps {
  nroCuenta: number;
}

export interface GetAssignedSlotsInRequestProps {
  id: number
}

export const getAssignedSlotsInRequest = async (
  props: GetAssignedSlotsInRequestProps,
): Promise<SlotMainData[] | undefined> => {
  const api = await getSlotRequestApi();
  if (!api) return;

  const response = await api.get(
    `/SolicitudCupos/${props?.id}/Asignados`,
  );

  return response.data;
};

